<mat-dialog-content>
    {{data.label}}:<br />
    <textarea [(ngModel)]='note' rows="5" cols="30" #noteTextbox></textarea>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button mat-dialog-close tabindex="-1">Cancel</button>
    <button mat-raised-button color="primary" (click)="onConfirmClick()" tabindex="1">OK</button>
</mat-dialog-actions>